import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { getVisitorSource } from '@/lib/visitorSource';

/**
 * Tracks authenticated page views by sending route changes
 * to the track-content-view edge function as "page_view" events.
 */
export function usePageViewTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const lastTrackedRef = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + (location.search || '');

    // Don't double-track the same path+query
    if (path === lastTrackedRef.current) return;
    lastTrackedRef.current = path;

    // Fire and forget - tracks anonymous visitors too (user_id is null when not signed in)
    supabase.functions.invoke('track-content-view', {
      body: {
        content_type: 'page_view',
        content_slug: path,
        user_id: user?.id,
        ...getVisitorSource(),
      },
    }).catch(() => {/* silent */});
  }, [user, location.pathname, location.search]);
}

